var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionsIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592",
    transform: "translate(-112 -237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M16,4H4A4,4,0,0,0,0,8v8a4,4,0,0,0,4,4H16a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4",
    transform: "translate(112 237)",
    fill: "#E65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M24,4v8a3.98,3.98,0,0,1-2,3.46V6a4,4,0,0,0-4-4H4.539A3.98,3.98,0,0,1,8,0H20a4,4,0,0,1,4,4",
    transform: "translate(112 237)",
    fill: "#E65847"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsIconSelected);
export default __webpack_public_path__ + "static/media/SubscriptionsIconSelected.8879b90844c278404101fbf60a78f4fa.svg";
export { ForwardRef as ReactComponent };